import type { NavNode } from "./types";
import type { Route } from "./route";

/** The route for a department node. The id decides; the slug is only for the address bar. */
export const deptRoute = (n: { id: string; slug: string }, qs?: string): Route => ({ name: "dept", id: n.id, slug: n.slug, qs });

/** The chain of nodes from a root down to `id`, or [] when the id is not in the tree. */
export function pathTo(tree: NavNode[], id: string): NavNode[] {
  for (const n of tree) {
    if (n.id === id) return [n];
    const below = pathTo(n.children, id);
    if (below.length > 0) return [n, ...below];
  }
  return [];
}

export function findNode(tree: NavNode[], id: string): NavNode | null {
  const p = pathTo(tree, id);
  return p[p.length - 1] ?? null;
}
